// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file shorturls/v1/shorturls.proto (package shorturls.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Destination, DestinationJson, Identity, IdentityJson } from "../../codes/v3/codes_pb";
import { file_codes_v3_codes } from "../../codes/v3/codes_pb";
import type { GS1DigitalLinkData, GS1DigitalLinkDataJson } from "../../codes/v3/destination_pb";
import { file_codes_v3_destination } from "../../codes/v3/destination_pb";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import { file_common_v1_events } from "../../common/v1/events_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { Creator, CreatorJson } from "../../common/v1/types_pb";
import { file_common_v1_types } from "../../common/v1/types_pb";
import type { FieldMask, FieldMaskJson, StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { MappedValue, MappedValueJson } from "../../workflows/v1/workflows_pb";
import { file_workflows_v1_workflows } from "../../workflows/v1/workflows_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file shorturls/v1/shorturls.proto.
 */
export const file_shorturls_v1_shorturls: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_codes_v3_codes, file_codes_v3_destination, file_common_v1_annotations, file_common_v1_events, file_common_v1_pagination, file_common_v1_types, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp, file_workflows_v1_workflows],
	);

/**
 * @generated from message shorturls.v1.ShortUrl
 */
export type ShortUrl = Message<"shorturls.v1.ShortUrl"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: Creator | undefined;

	/**
	 * @generated from field: optional string brand_kit_id = 19;
	 */
	brandKitId?: string | undefined;

	/**
	 * @generated from field: optional string domain_id = 7;
	 */
	domainId?: string | undefined;

	/**
	 * @generated from field: optional string batch_id = 8;
	 */
	batchId?: string | undefined;

	/**
	 * @generated from field: string state = 9;
	 */
	state: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath: string;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags: string[];

	/**
	 * @generated from field: string short_url = 12;
	 */
	shortUrl: string;

	/**
	 * @generated from field: string link_hash = 13;
	 */
	linkHash: string;

	/**
	 * @generated from field: string link_suffix = 14;
	 */
	linkSuffix: string;

	/**
	 * @generated from field: codes.v3.GS1DigitalLinkData gs1_data = 20 [deprecated = true];
	 * @deprecated
	 */
	gs1Data?: GS1DigitalLinkData | undefined;

	/**
	 * @generated from field: repeated codes.v3.Destination destinations = 15;
	 */
	destinations: Destination[];

	/**
	 * @generated from field: google.protobuf.Struct metadata = 16;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: codes.v3.Identity identity = 21;
	 */
	identity?: Identity | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 17;
	 */
	createdAt?: Timestamp | undefined;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 18;
	 */
	updatedAt?: Timestamp | undefined;
};

/**
 * @generated from message shorturls.v1.ShortUrl
 */
export type ShortUrlJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: string name = 2;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 5;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: common.v1.Creator creator = 6;
	 */
	creator?: CreatorJson;

	/**
	 * @generated from field: optional string brand_kit_id = 19;
	 */
	brandKitId?: string;

	/**
	 * @generated from field: optional string domain_id = 7;
	 */
	domainId?: string;

	/**
	 * @generated from field: optional string batch_id = 8;
	 */
	batchId?: string;

	/**
	 * @generated from field: string state = 9;
	 */
	state?: string;

	/**
	 * @generated from field: string folder_path = 10;
	 */
	folderPath?: string;

	/**
	 * @generated from field: repeated string tags = 11;
	 */
	tags?: string[];

	/**
	 * @generated from field: string short_url = 12;
	 */
	shortUrl?: string;

	/**
	 * @generated from field: string link_hash = 13;
	 */
	linkHash?: string;

	/**
	 * @generated from field: string link_suffix = 14;
	 */
	linkSuffix?: string;

	/**
	 * @generated from field: codes.v3.GS1DigitalLinkData gs1_data = 20 [deprecated = true];
	 * @deprecated
	 */
	gs1Data?: GS1DigitalLinkDataJson;

	/**
	 * @generated from field: repeated codes.v3.Destination destinations = 15;
	 */
	destinations?: DestinationJson[];

	/**
	 * @generated from field: google.protobuf.Struct metadata = 16;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: codes.v3.Identity identity = 21;
	 */
	identity?: IdentityJson;

	/**
	 * @generated from field: google.protobuf.Timestamp created_at = 17;
	 */
	createdAt?: TimestampJson;

	/**
	 * @generated from field: google.protobuf.Timestamp updated_at = 18;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message shorturls.v1.ShortUrl.
 * Use `create(ShortUrlSchema)` to create a new message.
 */
export const ShortUrlSchema: GenMessage<ShortUrl, { jsonType: ShortUrlJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 0);

/**
 * @generated from message shorturls.v1.ShortUrlCreated
 */
export type ShortUrlCreated = Message<"shorturls.v1.ShortUrlCreated"> & {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrl | undefined;
};

/**
 * @generated from message shorturls.v1.ShortUrlCreated
 */
export type ShortUrlCreatedJson = {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrlJson;
};

/**
 * Describes the message shorturls.v1.ShortUrlCreated.
 * Use `create(ShortUrlCreatedSchema)` to create a new message.
 */
export const ShortUrlCreatedSchema: GenMessage<ShortUrlCreated, { jsonType: ShortUrlCreatedJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 1);

/**
 * @generated from message shorturls.v1.CreateShortUrlRequest
 */
export type CreateShortUrlRequest = Message<"shorturls.v1.CreateShortUrlRequest"> & {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrl | undefined;
};

/**
 * @generated from message shorturls.v1.CreateShortUrlRequest
 */
export type CreateShortUrlRequestJson = {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrlJson;
};

/**
 * Describes the message shorturls.v1.CreateShortUrlRequest.
 * Use `create(CreateShortUrlRequestSchema)` to create a new message.
 */
export const CreateShortUrlRequestSchema: GenMessage<CreateShortUrlRequest, { jsonType: CreateShortUrlRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 2);

/**
 * @generated from message shorturls.v1.CreateShortUrlResponse
 */
export type CreateShortUrlResponse = Message<"shorturls.v1.CreateShortUrlResponse"> & {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrl | undefined;
};

/**
 * @generated from message shorturls.v1.CreateShortUrlResponse
 */
export type CreateShortUrlResponseJson = {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrlJson;
};

/**
 * Describes the message shorturls.v1.CreateShortUrlResponse.
 * Use `create(CreateShortUrlResponseSchema)` to create a new message.
 */
export const CreateShortUrlResponseSchema: GenMessage<CreateShortUrlResponse, { jsonType: CreateShortUrlResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 3);

/**
 * @generated from message shorturls.v1.GetShortUrlRequest
 */
export type GetShortUrlRequest = Message<"shorturls.v1.GetShortUrlRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * @generated from field: bool omit_default_metadata = 2;
	 */
	omitDefaultMetadata: boolean;
};

/**
 * @generated from message shorturls.v1.GetShortUrlRequest
 */
export type GetShortUrlRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * @generated from field: bool omit_default_metadata = 2;
	 */
	omitDefaultMetadata?: boolean;
};

/**
 * Describes the message shorturls.v1.GetShortUrlRequest.
 * Use `create(GetShortUrlRequestSchema)` to create a new message.
 */
export const GetShortUrlRequestSchema: GenMessage<GetShortUrlRequest, { jsonType: GetShortUrlRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 4);

/**
 * @generated from message shorturls.v1.GetShortUrlResponse
 */
export type GetShortUrlResponse = Message<"shorturls.v1.GetShortUrlResponse"> & {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrl | undefined;
};

/**
 * @generated from message shorturls.v1.GetShortUrlResponse
 */
export type GetShortUrlResponseJson = {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrlJson;
};

/**
 * Describes the message shorturls.v1.GetShortUrlResponse.
 * Use `create(GetShortUrlResponseSchema)` to create a new message.
 */
export const GetShortUrlResponseSchema: GenMessage<GetShortUrlResponse, { jsonType: GetShortUrlResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 5);

/**
 * @generated from message shorturls.v1.GetShortUrlInBatchRequest
 */
export type GetShortUrlInBatchRequest = Message<"shorturls.v1.GetShortUrlInBatchRequest"> & {
	/**
	 * The ID of the short URL to retrieve.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * ID of the batch to use.
	 *
	 * @generated from field: string batch_id = 2;
	 */
	batchId: string;

	/**
	 * The batch version to retrieve.
	 *
	 * @generated from field: optional string batch_version = 3;
	 */
	batchVersion?: string | undefined;

	/**
	 * Whether to omit the default metadata.
	 *
	 * @generated from field: bool omit_default_metadata = 4;
	 */
	omitDefaultMetadata: boolean;
};

/**
 * @generated from message shorturls.v1.GetShortUrlInBatchRequest
 */
export type GetShortUrlInBatchRequestJson = {
	/**
	 * The ID of the short URL to retrieve.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * ID of the batch to use.
	 *
	 * @generated from field: string batch_id = 2;
	 */
	batchId?: string;

	/**
	 * The batch version to retrieve.
	 *
	 * @generated from field: optional string batch_version = 3;
	 */
	batchVersion?: string;

	/**
	 * Whether to omit the default metadata.
	 *
	 * @generated from field: bool omit_default_metadata = 4;
	 */
	omitDefaultMetadata?: boolean;
};

/**
 * Describes the message shorturls.v1.GetShortUrlInBatchRequest.
 * Use `create(GetShortUrlInBatchRequestSchema)` to create a new message.
 */
export const GetShortUrlInBatchRequestSchema: GenMessage<GetShortUrlInBatchRequest, { jsonType: GetShortUrlInBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 6);

/**
 * @generated from message shorturls.v1.GetShortUrlInBatchResponse
 */
export type GetShortUrlInBatchResponse = Message<"shorturls.v1.GetShortUrlInBatchResponse"> & {
	/**
	 * The retrieved short URL.
	 *
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrl | undefined;
};

/**
 * @generated from message shorturls.v1.GetShortUrlInBatchResponse
 */
export type GetShortUrlInBatchResponseJson = {
	/**
	 * The retrieved short URL.
	 *
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrlJson;
};

/**
 * Describes the message shorturls.v1.GetShortUrlInBatchResponse.
 * Use `create(GetShortUrlInBatchResponseSchema)` to create a new message.
 */
export const GetShortUrlInBatchResponseSchema: GenMessage<GetShortUrlInBatchResponse, { jsonType: GetShortUrlInBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 7);

/**
 * @generated from message shorturls.v1.GetShortUrlsRequest
 */
export type GetShortUrlsRequest = Message<"shorturls.v1.GetShortUrlsRequest"> & {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids: string[];
};

/**
 * @generated from message shorturls.v1.GetShortUrlsRequest
 */
export type GetShortUrlsRequestJson = {
	/**
	 * @generated from field: repeated string ids = 1;
	 */
	ids?: string[];
};

/**
 * Describes the message shorturls.v1.GetShortUrlsRequest.
 * Use `create(GetShortUrlsRequestSchema)` to create a new message.
 */
export const GetShortUrlsRequestSchema: GenMessage<GetShortUrlsRequest, { jsonType: GetShortUrlsRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 8);

/**
 * @generated from message shorturls.v1.GetShortUrlsResponse
 */
export type GetShortUrlsResponse = Message<"shorturls.v1.GetShortUrlsResponse"> & {
	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl short_urls = 1;
	 */
	shortUrls: ShortUrl[];
};

/**
 * @generated from message shorturls.v1.GetShortUrlsResponse
 */
export type GetShortUrlsResponseJson = {
	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl short_urls = 1;
	 */
	shortUrls?: ShortUrlJson[];
};

/**
 * Describes the message shorturls.v1.GetShortUrlsResponse.
 * Use `create(GetShortUrlsResponseSchema)` to create a new message.
 */
export const GetShortUrlsResponseSchema: GenMessage<GetShortUrlsResponse, { jsonType: GetShortUrlsResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 9);

/**
 * @generated from message shorturls.v1.ListShortUrlsRequest
 */
export type ListShortUrlsRequest = Message<"shorturls.v1.ListShortUrlsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string | undefined;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix: string;

	/**
	 * @generated from field: optional string exact_name = 10;
	 */
	exactName?: string | undefined;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * @generated from field: string batch_id = 7;
	 */
	batchId: string;

	/**
	 * @generated from field: repeated string states = 9;
	 */
	states: string[];

	/**
	 * @generated from field: bool omit_default_metadata = 11;
	 */
	omitDefaultMetadata: boolean;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 8;
	 */
	pagination?: PaginationArguments | undefined;

	/**
	 * @generated from field: optional string batch_version = 12;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message shorturls.v1.ListShortUrlsRequest
 */
export type ListShortUrlsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: optional string folder_path = 3;
	 */
	folderPath?: string;

	/**
	 * @generated from field: string creator_id = 4;
	 */
	creatorId?: string;

	/**
	 * @generated from field: string name_prefix = 5;
	 */
	namePrefix?: string;

	/**
	 * @generated from field: optional string exact_name = 10;
	 */
	exactName?: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * @generated from field: string batch_id = 7;
	 */
	batchId?: string;

	/**
	 * @generated from field: repeated string states = 9;
	 */
	states?: string[];

	/**
	 * @generated from field: bool omit_default_metadata = 11;
	 */
	omitDefaultMetadata?: boolean;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 8;
	 */
	pagination?: PaginationArgumentsJson;

	/**
	 * @generated from field: optional string batch_version = 12;
	 */
	batchVersion?: string;
};

/**
 * Describes the message shorturls.v1.ListShortUrlsRequest.
 * Use `create(ListShortUrlsRequestSchema)` to create a new message.
 */
export const ListShortUrlsRequestSchema: GenMessage<ListShortUrlsRequest, { jsonType: ListShortUrlsRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 10);

/**
 * @generated from message shorturls.v1.ListShortUrlsResponse
 */
export type ListShortUrlsResponse = Message<"shorturls.v1.ListShortUrlsResponse"> & {
	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl short_urls = 1;
	 */
	shortUrls: ShortUrl[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo | undefined;
};

/**
 * @generated from message shorturls.v1.ListShortUrlsResponse
 */
export type ListShortUrlsResponseJson = {
	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl short_urls = 1;
	 */
	shortUrls?: ShortUrlJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message shorturls.v1.ListShortUrlsResponse.
 * Use `create(ListShortUrlsResponseSchema)` to create a new message.
 */
export const ListShortUrlsResponseSchema: GenMessage<ListShortUrlsResponse, { jsonType: ListShortUrlsResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 11);

/**
 * @generated from message shorturls.v1.UpdateShortUrlRequest
 */
export type UpdateShortUrlRequest = Message<"shorturls.v1.UpdateShortUrlRequest"> & {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrl | undefined;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask | undefined;

	/**
	 * @generated from field: optional string batch_version = 3;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message shorturls.v1.UpdateShortUrlRequest
 */
export type UpdateShortUrlRequestJson = {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrlJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;

	/**
	 * @generated from field: optional string batch_version = 3;
	 */
	batchVersion?: string;
};

/**
 * Describes the message shorturls.v1.UpdateShortUrlRequest.
 * Use `create(UpdateShortUrlRequestSchema)` to create a new message.
 */
export const UpdateShortUrlRequestSchema: GenMessage<UpdateShortUrlRequest, { jsonType: UpdateShortUrlRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 12);

/**
 * @generated from message shorturls.v1.UpdateShortUrlResponse
 */
export type UpdateShortUrlResponse = Message<"shorturls.v1.UpdateShortUrlResponse"> & {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrl | undefined;
};

/**
 * @generated from message shorturls.v1.UpdateShortUrlResponse
 */
export type UpdateShortUrlResponseJson = {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrlJson;
};

/**
 * Describes the message shorturls.v1.UpdateShortUrlResponse.
 * Use `create(UpdateShortUrlResponseSchema)` to create a new message.
 */
export const UpdateShortUrlResponseSchema: GenMessage<UpdateShortUrlResponse, { jsonType: UpdateShortUrlResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 13);

/**
 * @generated from message shorturls.v1.DeleteShortUrlRequest
 */
export type DeleteShortUrlRequest = Message<"shorturls.v1.DeleteShortUrlRequest"> & {
	/**
	 * @generated from field: string id = 1;
	 */
	id: string;
};

/**
 * @generated from message shorturls.v1.DeleteShortUrlRequest
 */
export type DeleteShortUrlRequestJson = {
	/**
	 * @generated from field: string id = 1;
	 */
	id?: string;
};

/**
 * Describes the message shorturls.v1.DeleteShortUrlRequest.
 * Use `create(DeleteShortUrlRequestSchema)` to create a new message.
 */
export const DeleteShortUrlRequestSchema: GenMessage<DeleteShortUrlRequest, { jsonType: DeleteShortUrlRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 14);

/**
 * @generated from message shorturls.v1.DeleteShortUrlResponse
 */
export type DeleteShortUrlResponse = Message<"shorturls.v1.DeleteShortUrlResponse"> & {};

/**
 * @generated from message shorturls.v1.DeleteShortUrlResponse
 */
export type DeleteShortUrlResponseJson = {};

/**
 * Describes the message shorturls.v1.DeleteShortUrlResponse.
 * Use `create(DeleteShortUrlResponseSchema)` to create a new message.
 */
export const DeleteShortUrlResponseSchema: GenMessage<DeleteShortUrlResponse, { jsonType: DeleteShortUrlResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 15);

/**
 * @generated from message shorturls.v1.AddShortUrlToBatchRequest
 */
export type AddShortUrlToBatchRequest = Message<"shorturls.v1.AddShortUrlToBatchRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name: string;

	/**
	 * @generated from field: string description = 5;
	 */
	description: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags: string[];

	/**
	 * @generated from field: string link_suffix = 8;
	 */
	linkSuffix: string;

	/**
	 * @generated from field: string link_hash = 9;
	 */
	linkHash: string;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 7;
	 */
	metadata?: JsonObject | undefined;

	/**
	 * @generated from field: codes.v3.Identity identity = 12;
	 */
	identity?: Identity | undefined;

	/**
	 * @generated from field: optional string batch_version = 10;
	 */
	batchVersion?: string | undefined;

	/**
	 * @generated from field: codes.v3.GS1DigitalLinkData gs1_data = 11 [deprecated = true];
	 * @deprecated
	 */
	gs1Data?: GS1DigitalLinkData | undefined;
};

/**
 * @generated from message shorturls.v1.AddShortUrlToBatchRequest
 */
export type AddShortUrlToBatchRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * @generated from field: string name = 4;
	 */
	name?: string;

	/**
	 * @generated from field: string description = 5;
	 */
	description?: string;

	/**
	 * @generated from field: repeated string tags = 6;
	 */
	tags?: string[];

	/**
	 * @generated from field: string link_suffix = 8;
	 */
	linkSuffix?: string;

	/**
	 * @generated from field: string link_hash = 9;
	 */
	linkHash?: string;

	/**
	 * @generated from field: google.protobuf.Struct metadata = 7;
	 */
	metadata?: StructJson;

	/**
	 * @generated from field: codes.v3.Identity identity = 12;
	 */
	identity?: IdentityJson;

	/**
	 * @generated from field: optional string batch_version = 10;
	 */
	batchVersion?: string;

	/**
	 * @generated from field: codes.v3.GS1DigitalLinkData gs1_data = 11 [deprecated = true];
	 * @deprecated
	 */
	gs1Data?: GS1DigitalLinkDataJson;
};

/**
 * Describes the message shorturls.v1.AddShortUrlToBatchRequest.
 * Use `create(AddShortUrlToBatchRequestSchema)` to create a new message.
 */
export const AddShortUrlToBatchRequestSchema: GenMessage<AddShortUrlToBatchRequest, { jsonType: AddShortUrlToBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 16);

/**
 * @generated from message shorturls.v1.AddShortUrlToBatchResponse
 */
export type AddShortUrlToBatchResponse = Message<"shorturls.v1.AddShortUrlToBatchResponse"> & {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrl | undefined;
};

/**
 * @generated from message shorturls.v1.AddShortUrlToBatchResponse
 */
export type AddShortUrlToBatchResponseJson = {
	/**
	 * @generated from field: shorturls.v1.ShortUrl short_url = 1;
	 */
	shortUrl?: ShortUrlJson;
};

/**
 * Describes the message shorturls.v1.AddShortUrlToBatchResponse.
 * Use `create(AddShortUrlToBatchResponseSchema)` to create a new message.
 */
export const AddShortUrlToBatchResponseSchema: GenMessage<AddShortUrlToBatchResponse, { jsonType: AddShortUrlToBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 17);

/**
 * @generated from message shorturls.v1.AddShortUrlsToBatchRequest
 */
export type AddShortUrlsToBatchRequest = Message<"shorturls.v1.AddShortUrlsToBatchRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * @generated from field: repeated shorturls.v1.AddShortUrlToBatchRequest requests = 4;
	 */
	requests: AddShortUrlToBatchRequest[];

	/**
	 * @generated from field: optional string batch_version = 5;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message shorturls.v1.AddShortUrlsToBatchRequest
 */
export type AddShortUrlsToBatchRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * @generated from field: repeated shorturls.v1.AddShortUrlToBatchRequest requests = 4;
	 */
	requests?: AddShortUrlToBatchRequestJson[];

	/**
	 * @generated from field: optional string batch_version = 5;
	 */
	batchVersion?: string;
};

/**
 * Describes the message shorturls.v1.AddShortUrlsToBatchRequest.
 * Use `create(AddShortUrlsToBatchRequestSchema)` to create a new message.
 */
export const AddShortUrlsToBatchRequestSchema: GenMessage<AddShortUrlsToBatchRequest, { jsonType: AddShortUrlsToBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 18);

/**
 * @generated from message shorturls.v1.AddShortUrlsToBatchResponse
 */
export type AddShortUrlsToBatchResponse = Message<"shorturls.v1.AddShortUrlsToBatchResponse"> & {
	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl short_urls = 1;
	 */
	shortUrls: ShortUrl[];
};

/**
 * @generated from message shorturls.v1.AddShortUrlsToBatchResponse
 */
export type AddShortUrlsToBatchResponseJson = {
	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl short_urls = 1;
	 */
	shortUrls?: ShortUrlJson[];
};

/**
 * Describes the message shorturls.v1.AddShortUrlsToBatchResponse.
 * Use `create(AddShortUrlsToBatchResponseSchema)` to create a new message.
 */
export const AddShortUrlsToBatchResponseSchema: GenMessage<AddShortUrlsToBatchResponse, { jsonType: AddShortUrlsToBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 19);

/**
 * @generated from message shorturls.v1.UpsertShortUrlsInBatchRequest
 */
export type UpsertShortUrlsInBatchRequest = Message<"shorturls.v1.UpsertShortUrlsInBatchRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * @generated from field: repeated shorturls.v1.AddShortUrlToBatchRequest requests = 4;
	 */
	requests: AddShortUrlToBatchRequest[];

	/**
	 * @generated from field: optional string batch_version = 5;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message shorturls.v1.UpsertShortUrlsInBatchRequest
 */
export type UpsertShortUrlsInBatchRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * @generated from field: repeated shorturls.v1.AddShortUrlToBatchRequest requests = 4;
	 */
	requests?: AddShortUrlToBatchRequestJson[];

	/**
	 * @generated from field: optional string batch_version = 5;
	 */
	batchVersion?: string;
};

/**
 * Describes the message shorturls.v1.UpsertShortUrlsInBatchRequest.
 * Use `create(UpsertShortUrlsInBatchRequestSchema)` to create a new message.
 */
export const UpsertShortUrlsInBatchRequestSchema: GenMessage<UpsertShortUrlsInBatchRequest, { jsonType: UpsertShortUrlsInBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 20);

/**
 * @generated from message shorturls.v1.UpsertShortUrlsInBatchResponse
 */
export type UpsertShortUrlsInBatchResponse = Message<"shorturls.v1.UpsertShortUrlsInBatchResponse"> & {
	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl created = 1;
	 */
	created: ShortUrl[];

	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl updated = 2;
	 */
	updated: ShortUrl[];
};

/**
 * @generated from message shorturls.v1.UpsertShortUrlsInBatchResponse
 */
export type UpsertShortUrlsInBatchResponseJson = {
	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl created = 1;
	 */
	created?: ShortUrlJson[];

	/**
	 * @generated from field: repeated shorturls.v1.ShortUrl updated = 2;
	 */
	updated?: ShortUrlJson[];
};

/**
 * Describes the message shorturls.v1.UpsertShortUrlsInBatchResponse.
 * Use `create(UpsertShortUrlsInBatchResponseSchema)` to create a new message.
 */
export const UpsertShortUrlsInBatchResponseSchema: GenMessage<UpsertShortUrlsInBatchResponse, { jsonType: UpsertShortUrlsInBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 21);

/**
 * @generated from message shorturls.v1.UpdateShortUrlsInBatchRequest
 */
export type UpdateShortUrlsInBatchRequest = Message<"shorturls.v1.UpdateShortUrlsInBatchRequest"> & {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * Batch ID is the batch that the short urls belong to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * List of requests for short urls to update within the batch. Valid fields to update are: name and metadata.
	 *
	 * @generated from field: repeated shorturls.v1.UpdateShortUrlRequest requests = 4;
	 */
	requests: UpdateShortUrlRequest[];
};

/**
 * @generated from message shorturls.v1.UpdateShortUrlsInBatchRequest
 */
export type UpdateShortUrlsInBatchRequestJson = {
	/**
	 * Org ID is the organization that the batch belongs to.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * Workspace ID is the workspace that the batch belongs to. Must be associated with the org_id.
	 *
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * Batch ID is the batch that the short urls belong to.
	 *
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * List of requests for short urls to update within the batch. Valid fields to update are: name and metadata.
	 *
	 * @generated from field: repeated shorturls.v1.UpdateShortUrlRequest requests = 4;
	 */
	requests?: UpdateShortUrlRequestJson[];
};

/**
 * Describes the message shorturls.v1.UpdateShortUrlsInBatchRequest.
 * Use `create(UpdateShortUrlsInBatchRequestSchema)` to create a new message.
 */
export const UpdateShortUrlsInBatchRequestSchema: GenMessage<UpdateShortUrlsInBatchRequest, { jsonType: UpdateShortUrlsInBatchRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 22);

/**
 * @generated from message shorturls.v1.UpdateShortUrlsInBatchResponse
 */
export type UpdateShortUrlsInBatchResponse = Message<"shorturls.v1.UpdateShortUrlsInBatchResponse"> & {
	/**
	 * ShortUrls that were updated in the batch.
	 *
	 * @generated from field: repeated shorturls.v1.ShortUrl short_urls = 1;
	 */
	shortUrls: ShortUrl[];
};

/**
 * @generated from message shorturls.v1.UpdateShortUrlsInBatchResponse
 */
export type UpdateShortUrlsInBatchResponseJson = {
	/**
	 * ShortUrls that were updated in the batch.
	 *
	 * @generated from field: repeated shorturls.v1.ShortUrl short_urls = 1;
	 */
	shortUrls?: ShortUrlJson[];
};

/**
 * Describes the message shorturls.v1.UpdateShortUrlsInBatchResponse.
 * Use `create(UpdateShortUrlsInBatchResponseSchema)` to create a new message.
 */
export const UpdateShortUrlsInBatchResponseSchema: GenMessage<UpdateShortUrlsInBatchResponse, { jsonType: UpdateShortUrlsInBatchResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 23);

/**
 * @generated from message shorturls.v1.BulkImportShortUrlsRequest
 */
export type BulkImportShortUrlsRequest = Message<"shorturls.v1.BulkImportShortUrlsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId: string;

	/**
	 * @generated from field: string file_url = 4;
	 */
	fileUrl: string;

	/**
	 * @generated from field: string audience_id = 9;
	 */
	audienceId: string;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 5;
	 */
	mapping: { [key: string]: MappedValue };

	/**
	 * @generated from field: bool has_header = 6;
	 */
	hasHeader: boolean;

	/**
	 * @generated from field: repeated string header = 7;
	 */
	header: string[];

	/**
	 * @generated from field: optional string batch_version = 8;
	 */
	batchVersion?: string | undefined;
};

/**
 * @generated from message shorturls.v1.BulkImportShortUrlsRequest
 */
export type BulkImportShortUrlsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: string workspace_id = 2;
	 */
	workspaceId?: string;

	/**
	 * @generated from field: string batch_id = 3;
	 */
	batchId?: string;

	/**
	 * @generated from field: string file_url = 4;
	 */
	fileUrl?: string;

	/**
	 * @generated from field: string audience_id = 9;
	 */
	audienceId?: string;

	/**
	 * @generated from field: map<string, workflows.v1.MappedValue> mapping = 5;
	 */
	mapping?: { [key: string]: MappedValueJson };

	/**
	 * @generated from field: bool has_header = 6;
	 */
	hasHeader?: boolean;

	/**
	 * @generated from field: repeated string header = 7;
	 */
	header?: string[];

	/**
	 * @generated from field: optional string batch_version = 8;
	 */
	batchVersion?: string;
};

/**
 * Describes the message shorturls.v1.BulkImportShortUrlsRequest.
 * Use `create(BulkImportShortUrlsRequestSchema)` to create a new message.
 */
export const BulkImportShortUrlsRequestSchema: GenMessage<BulkImportShortUrlsRequest, { jsonType: BulkImportShortUrlsRequestJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 24);

/**
 * @generated from message shorturls.v1.BulkImportShortUrlsResponse
 */
export type BulkImportShortUrlsResponse = Message<"shorturls.v1.BulkImportShortUrlsResponse"> & {};

/**
 * @generated from message shorturls.v1.BulkImportShortUrlsResponse
 */
export type BulkImportShortUrlsResponseJson = {};

/**
 * Describes the message shorturls.v1.BulkImportShortUrlsResponse.
 * Use `create(BulkImportShortUrlsResponseSchema)` to create a new message.
 */
export const BulkImportShortUrlsResponseSchema: GenMessage<BulkImportShortUrlsResponse, { jsonType: BulkImportShortUrlsResponseJson }> = /*@__PURE__*/ messageDesc(file_shorturls_v1_shorturls, 25);

/**
 * @generated from service shorturls.v1.ShortUrlsService
 */
export const ShortUrlsService: GenService<{
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.CreateShortUrl
	 */
	createShortUrl: {
		methodKind: "unary";
		input: typeof CreateShortUrlRequestSchema;
		output: typeof CreateShortUrlResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.GetShortUrl
	 */
	getShortUrl: {
		methodKind: "unary";
		input: typeof GetShortUrlRequestSchema;
		output: typeof GetShortUrlResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.GetShortUrlInBatch
	 */
	getShortUrlInBatch: {
		methodKind: "unary";
		input: typeof GetShortUrlInBatchRequestSchema;
		output: typeof GetShortUrlInBatchResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.GetShortUrls
	 */
	getShortUrls: {
		methodKind: "unary";
		input: typeof GetShortUrlsRequestSchema;
		output: typeof GetShortUrlsResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.ListShortUrls
	 */
	listShortUrls: {
		methodKind: "unary";
		input: typeof ListShortUrlsRequestSchema;
		output: typeof ListShortUrlsResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.UpdateShortUrl
	 */
	updateShortUrl: {
		methodKind: "unary";
		input: typeof UpdateShortUrlRequestSchema;
		output: typeof UpdateShortUrlResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.DeleteShortUrl
	 */
	deleteShortUrl: {
		methodKind: "unary";
		input: typeof DeleteShortUrlRequestSchema;
		output: typeof DeleteShortUrlResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.AddShortUrlToBatch
	 */
	addShortUrlToBatch: {
		methodKind: "unary";
		input: typeof AddShortUrlToBatchRequestSchema;
		output: typeof AddShortUrlToBatchResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.AddShortUrlsToBatch
	 */
	addShortUrlsToBatch: {
		methodKind: "unary";
		input: typeof AddShortUrlsToBatchRequestSchema;
		output: typeof AddShortUrlsToBatchResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.UpsertShortUrlsInBatch
	 */
	upsertShortUrlsInBatch: {
		methodKind: "unary";
		input: typeof UpsertShortUrlsInBatchRequestSchema;
		output: typeof UpsertShortUrlsInBatchResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.UpdateShortUrlsInBatch
	 */
	updateShortUrlsInBatch: {
		methodKind: "unary";
		input: typeof UpdateShortUrlsInBatchRequestSchema;
		output: typeof UpdateShortUrlsInBatchResponseSchema;
	};
	/**
	 * @generated from rpc shorturls.v1.ShortUrlsService.BulkImportShortUrls
	 */
	bulkImportShortUrls: {
		methodKind: "unary";
		input: typeof BulkImportShortUrlsRequestSchema;
		output: typeof BulkImportShortUrlsResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_shorturls_v1_shorturls, 0);
